import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { TGroupListItem } from 'user/types';
import { isGroupSelected } from 'user/utils';

import { SkillGroupSelectorListItem } from './SkillGroupSelectorListItem';

interface IProps {
    addedGroups: TGroupListItem[];
    selectedGroups: TGroupListItem[];
    groups: TGroupListItem[];
    onAddGroup?(selectedGroup: TGroupListItem): void;
    onRemoveGroup?(selectedGroup: TGroupListItem): void;
}

export const SkillGroupAddList = ({
    addedGroups,
    selectedGroups,
    groups,
    onAddGroup,
    onRemoveGroup,
}: IProps) => {
    const [translate] = useTranslation();

    return (
        <>
            {!groups.length ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 7,
                    }}
                >
                    <Typography>{translate('noOptionsText.groups')}</Typography>
                </Box>
            ) : (
                groups.filter(Boolean).map((group) => {
                    const isSelected = isGroupSelected(selectedGroups, group);
                    const isAdded = isGroupSelected(addedGroups, group);

                    return (
                        <SkillGroupSelectorListItem
                            added={isAdded}
                            group={group}
                            key={group.id}
                            px={2}
                            selected={isSelected}
                            onClick={() =>
                                isSelected
                                    ? onRemoveGroup?.(group)
                                    : onAddGroup?.(group)
                            }
                        />
                    );
                })
            )}
        </>
    );
};
